import WebService from "../WebService";

const AttendeeMessage = {
  create(data) {
    return WebService.post("/attendee_messages", data);
  },
  update(data) {
    return WebService.post("/attendee_messages/" + data.message_id, data);
  },
  gets(params) {
    return WebService.get("/attendee_messages?" + params);
  },
  get(message_id) {
    return WebService.get("/attendee_messages/" + message_id);
  },
  send(data) {
    return WebService.post(
      "/attendee_messages/" + data.message_id + "/send",
      data
    );
  }
};

export default AttendeeMessage;
